import { Link } from 'react-router-dom';

const shortcuts = [
  {
    to: '/movies',
    icon: 'ri-film-line',
    title: '电影',
    subtitle: '院线新片与经典佳作，按类型与年份筛选',
    count: '128 部作品',
    wrapper: 'bg-primary-500 text-background-50',
    iconBox: 'bg-background-50/15 text-background-50',
    hint: 'text-background-100/80',
    arrow: 'text-background-50',
  },
  {
    to: '/tvshows',
    icon: 'ri-tv-2-line',
    title: '电视剧',
    subtitle: '国产、欧美、日韩剧集，连载状态一目了然',
    count: '76 部剧集',
    wrapper: 'bg-background-100 text-foreground-950',
    iconBox: 'bg-accent-500 text-foreground-950',
    hint: 'text-foreground-600',
    arrow: 'text-foreground-700',
  },
  {
    to: '/news',
    icon: 'ri-newspaper-line',
    title: '影视资讯',
    subtitle: '行业动态、明星消息与深度影评每日更新',
    count: '今日更新 8 条',
    wrapper: 'bg-secondary-500 text-background-50',
    iconBox: 'bg-background-50/15 text-background-50',
    hint: 'text-background-100/80',
    arrow: 'text-background-50',
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="relative z-20 w-full px-4 md:px-8">
      <div className="mt-5 grid grid-cols-1 gap-3 md:mt-8 md:grid-cols-3 md:gap-4">
        {shortcuts.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`group flex cursor-pointer items-start gap-4 rounded-lg p-4 transition-transform duration-300 hover:-translate-y-1 md:p-5 ${item.wrapper}`}
          >
            <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md ${item.iconBox}`}>
              <i className={`${item.icon} text-[21px]`}></i>
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center justify-between gap-2">
                <span className="font-heading text-base font-semibold">{item.title}</span>
                <i className={`${item.arrow} ri-arrow-right-up-line text-[16px] transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5`}></i>
              </span>
              <span className={`mt-1.5 block text-xs leading-relaxed ${item.hint}`}>{item.subtitle}</span>
              <span className={`mt-3 block font-label text-[11px] tracking-wide ${item.hint}`}>
                {item.count}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}